var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "container"
  }, [_c("div", {
    staticClass: "top-wrap"
  }), _c("div", {
    staticClass: "titleBar"
  }, [_c("div", {
    staticClass: "img-wrap",
    on: {
      click: _vm.back
    }
  }, [_c("img", {
    attrs: {
      src: require("../../assets/images/arrow.png"),
      alt: ""
    }
  })]), _c("div", {
    staticClass: "center"
  }, [_vm._v("My Account")]), _c("div", {
    staticClass: "img-wrap"
  })]), _c("div", {
    staticClass: "content"
  }, [_c("div", {
    staticClass: "demo"
  }, [_c("div", {
    staticClass: "cropper"
  }, [_c("img", {
    staticClass: "img",
    attrs: {
      src: _vm.img
    }
  }), _vm.isShowLoading ? _c("div", {
    staticClass: "uploading"
  }, [_vm._v(_vm._s(_vm.state))]) : _vm._e(), _c("h5-cropper", {
    attrs: {
      option: _vm.option
    },
    on: {
      getbase64Data: _vm.getbase64Data,
      getblobData: _vm.getblobData,
      getFile: _vm.getFile
    }
  }), _c("img", {
    staticClass: "small-img",
    attrs: {
      src: require("../../assets/images/Camera@2x.png"),
      alt: ""
    }
  })], 1)]), _c("div", {
    staticClass: "login-box"
  }, [_c("div", {
    staticClass: "password1"
  }, [_c("span", {
    staticClass: "top"
  }, [_vm._v("name")]), _c("div", {
    staticClass: "bottom"
  }, [_c("input", {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.nickname,
      expression: "nickname"
    }],
    attrs: {
      type: "text",
      placeholder: "Enter Name"
    },
    domProps: {
      value: _vm.nickname
    },
    on: {
      input: [function ($event) {
        if ($event.target.composing) return;
        _vm.nickname = $event.target.value;
      }, _vm.input],
      focus: function focus($event) {
        return _vm.focus(".password1 .bottom");
      },
      blur: function blur($event) {
        return _vm.blur(".password1 .bottom");
      }
    }
  })])]), _c("div", {
    staticClass: "password1"
  }, [_c("span", {
    staticClass: "top"
  }, [_vm._v("Your Description")]), _c("div", {
    staticClass: "bottom"
  }, [_c("input", {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.signature,
      expression: "signature"
    }],
    attrs: {
      type: "text",
      placeholder: "Enter Description"
    },
    domProps: {
      value: _vm.signature
    },
    on: {
      input: [function ($event) {
        if ($event.target.composing) return;
        _vm.signature = $event.target.value;
      }, _vm.input],
      focus: function focus($event) {
        return _vm.focus(".password1 .bottom");
      },
      blur: function blur($event) {
        return _vm.blur(".password1 .bottom");
      }
    }
  })])]), _c("div", {
    staticClass: "password2"
  }, [_c("span", {
    staticClass: "top"
  }, [_vm._v("Gender")]), _c("div", {
    staticClass: "bottom"
  }, [_c("div", {
    on: {
      click: _vm.showGenderPop
    }
  }, [_c("input", {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.gender,
      expression: "gender"
    }],
    attrs: {
      disabled: "",
      placeholder: "Enter Gender"
    },
    domProps: {
      value: _vm.gender
    },
    on: {
      input: function input($event) {
        if ($event.target.composing) return;
        _vm.gender = $event.target.value;
      }
    }
  })]), _c("van-popup", {
    style: {
      height: 300
    },
    attrs: {
      position: "bottom"
    },
    model: {
      value: _vm.showGender,
      callback: function callback($$v) {
        _vm.showGender = $$v;
      },
      expression: "showGender"
    }
  }, [_c("van-picker", {
    attrs: {
      height: "300",
      "show-toolbar": "",
      columns: _vm.genderArr
    },
    on: {
      confirm: _vm.onConfirm,
      cancel: _vm.onCancel,
      change: _vm.onChange
    }
  })], 1), _vm._m(0)], 1)]), _c("div", {
    staticClass: "password3"
  }, [_c("span", {
    staticClass: "top"
  }, [_vm._v("Birthday")]), _c("div", {
    staticClass: "bottom"
  }, [_c("div", {
    on: {
      click: _vm.showBirthPop
    }
  }, [_c("input", {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.birthday,
      expression: "birthday"
    }],
    attrs: {
      disabled: "",
      placeholder: "Enter birthday"
    },
    domProps: {
      value: _vm.birthday
    },
    on: {
      input: function input($event) {
        if ($event.target.composing) return;
        _vm.birthday = $event.target.value;
      }
    }
  })]), _c("van-popup", {
    style: {
      height: 300
    },
    attrs: {
      position: "bottom"
    },
    model: {
      value: _vm.showBirth,
      callback: function callback($$v) {
        _vm.showBirth = $$v;
      },
      expression: "showBirth"
    }
  }, [_c("van-datetime-picker", {
    attrs: {
      height: "300",
      type: "date",
      title: "选择年月日",
      "min-date": _vm.minDate,
      "max-date": _vm.maxDate
    },
    on: {
      confirm: _vm.onConfirm1,
      cancel: _vm.onCancel1,
      change: _vm.onChange1
    },
    model: {
      value: _vm.currentDate,
      callback: function callback($$v) {
        _vm.currentDate = $$v;
      },
      expression: "currentDate"
    }
  })], 1), _vm._m(1)], 1)]), _c("div", {
    staticClass: "password1"
  }, [_c("span", {
    staticClass: "top"
  }, [_vm._v("Emergency Contact")]), _c("div", {
    staticClass: "bottom"
  }, [_c("input", {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.emergencyNum,
      expression: "emergencyNum"
    }],
    attrs: {
      type: "text",
      placeholder: "Emergency contact Number"
    },
    domProps: {
      value: _vm.emergencyNum
    },
    on: {
      input: [function ($event) {
        if ($event.target.composing) return;
        _vm.emergencyNum = $event.target.value;
      }, _vm.input],
      focus: function focus($event) {
        return _vm.focus(".password1 .bottom");
      },
      blur: function blur($event) {
        return _vm.blur(".password1 .bottom");
      }
    }
  })])])]), _c("div", {
    class: ["btn", {
      active: _vm.isActive
    }],
    on: {
      click: _vm.toSubmit
    }
  }, [_vm._v(_vm._s(_vm.$t("Save")))])])]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("img", {
    attrs: {
      src: require("../../assets/images/Search-more.png"),
      alt: ""
    }
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("img", {
    attrs: {
      src: require("../../assets/images/Search-more.png"),
      alt: ""
    }
  })]);
}];
render._withStripped = true;
export { render, staticRenderFns };